(() => {
  if (customElements.get('ombre-product-presentation')) return;
  customElements.define('ombre-product-presentation', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-ombre-native-product-detail]');
      this.onChange = () => this.update();
      this.root?.addEventListener('change', this.onChange);
      this.update();
    }

    disconnectedCallback() {
      this.root?.removeEventListener('change', this.onChange);
    }

    update() {
      const selected = Array.from(this.root?.querySelectorAll('[data-ombre-option-input]:checked') || [])
        .find((input) => input.dataset.optionPosition === this.dataset.colorPosition);
      // Preserve the server-rendered selection when a product has no visible options.
      if (!selected) return;
      this.querySelectorAll('[data-presentation-colorway]').forEach((panel) => {
        panel.hidden = panel.dataset.presentationColorway !== selected.value;
      });
    }
  });
})();
